module.exports = __webpack_public_path__ + "img/party_upper_4.4b45cd05.jpg";